<template>
  <div class="centered">
    <p><strong>{{ $t('NoHayCultivos') }}<strong /></strong></p>
    <p>{{ $t('common.pleasePress') }} <img :src="iconCreateCrop"> {{ $t('ParaCrearUnCultivo') }}</p>
  </div>
</template>

<script>
import icCreateCrop from '@/static/img/ic_create_crop.svg';

export default {
  name: 'NoCropsInfo',

  computed: {
    iconCreateCrop() {
      return icCreateCrop;
    },
  },
};
</script>

<style scoped lang="scss">
.centered {
  text-align: center;
  padding: 5px;
}
</style>
